
import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FiX } from 'react-icons/fi';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { navigationActions } from '../actions/navigationActions';
import { useNavigation } from './NavigationProvider';
import './privacyPage.css';

const StyledPrivacySummaryRow = styled(Row)`
    margin-bottom: 18.75rem;

    @media (min-width: 768px) {
        margin-bottom: 12rem;
    }
`;

export const PrivacyPolicyPage = ({ history }) => {
    const [, dispatch] = useNavigation();
    const intl = useIntl();

    const ButtonBack = () => {
        return (
            <Button
                className="text-white border-0 btn-lg button-message"
                onClick={() => {
                    history.push("/");
                    navigationActions.changeNavigation("/", dispatch);
                }}
                style={{
                    borderRadius: 0,
                    backgroundColor: "#092451"
                }}
            >
                <FiX className="button-arrow" />

                <b>
                    {intl.formatMessage({id: "privacyPolicy.tornaHome"})}
                </b>
            </Button>
        )
    };

    return (
        <React.Fragment>
            <Container fluid className="w-75">
                <Row lg={12} md={12} sm={12} sx={12} className="m-2">
                    <Col className="my-auto p-0">
                        <h1 className="policy-title" style={{ fontSize: "3rem" }}> {intl.formatMessage({ id: `privacyPolicy.privacyPolicyTitle`})} </h1>
                    </Col>
                    <Col align="right" className="my-auto p-0">
                        <ButtonBack />
                    </Col>
                </Row>
                <StyledPrivacySummaryRow>
                    <Col>
                        <Card style={{ marginBottom: "1rem", borderRadius: "8px" }} >
                            <Card.Body>
                                <Card.Text style={{ whiteSpace: 'pre-line' }}>
                                  { intl.formatMessage({ id: 'privacyPolicy.summary' }) }
                                  <br />
                                  <br />
                                  <a target="_blank" href="https://www.policlinicocampusbiomedico.it/privacy-policy-app-dea">
                                    { intl.formatMessage({ id: 'privacyPolicy.ulterioriDettagli' }) }
                                  </a>
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                </StyledPrivacySummaryRow>
            </Container>
        </React.Fragment>
    )
}
